import type { UnitOfMeasureResponse } from 'api/__GENERATED';

// Maps a single UnitOfMeasure DTO from the generated API client onto the
// normalized `Data.UnitOfMeasure` shape. Only `description` is nullable in
// the DTO; `name` and `abbreviation` are guaranteed. Tenant scoping is
// implicit at this layer, so `TenantId` is intentionally ignored.
function toUnitOfMeasure(dto: UnitOfMeasureResponse) {
  const { id, name, description, abbreviation } = dto;

  const unitOfMeasure: Data.UnitOfMeasure = {
    id,
    name,
    description: description ?? '',
    abbreviation,
  };

  return unitOfMeasure;
}

export { toUnitOfMeasure };
